<template>
  <div>
    <div class="sessions" role="tablist">
      <b-row v-if="false">
        <b-col>
          <div class="float-left">
            <b-button variant="primary">
              New Inquiries
              <b-badge variant="light">
                {{ newAssessmentsCount }} / {{ assessmentsCount }}
                <span class="sr-only">
                  unread messages
                </span>
              </b-badge>
            </b-button>
          </div>
          <b-button
            style="margin-left: 25px;"
            variant="primary"
            :disabled="!canGenerate"
            @click="handleGeneratePlan"
          >
            Generate
          </b-button>
          <b-button
            style="margin-left: 25px;"
            variant="primary"
            :disabled="!canSaveAssessment"
            @click="handleUpdateAssessment"
          >
            Save Assessment
          </b-button>
        </b-col>
      </b-row>
      <b-row style="margin-top: 25px;">
        <b-col>
          <assessment-input
            :assessment-idx="assessmentIdx"
            :assessment="currAssessment"
            :new-assessment-count="newAssessmentsCount"
            :max-assessments="assessmentsCount"
            @generate-plan="handleGeneratePlan"
            @input-form="handleQuestionAnswerInput"
            @page-to="handleAssessmentPageTo"
          />
        </b-col>
      </b-row>
    </div>
    <b-row v--if="false" style="margin-top: 25px;">
      <b-col>
        May we have a care plan specialist review your plan?
        <toggle-single
          id="toggle"
          label-name="May we have a care plan specialist review your plan?"
          :toggle-model="isViewableForCPS"
          @toggle-click="handleToggleClick"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AssessmentInput from "./assessmentInput";
import ToggleSingle from "@/components/common/toggleSingle";
export default {
  name: "Base_Assessment",
  components: {
    AssessmentInput,
    ToggleSingle
  },
  created() {},
  beforeMount() {},
  mounted() {
    this.processDoc();
  },
  props: {
    carePlan: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    heartbeat: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    assessments: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    assessmentsUnanswered: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    fam: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    profile: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    path: {
      type: String,
      required: true,
      default: ""
    },
    pathRootDoc: {
      type: String,
      required: true,
      default: ""
    },
    doc: {
      type: Object,
      default: () => {
        return {};
      }
    },
    output: {
      type: Object,
      default: () => {
        return {};
      }
    },
    section: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters({}),
    currAssessment() {
      return this.assessments &&
        Array.isArray(this.assessments) &&
        this.assessmentIdx !== "undefined" &&
        this.assessments.length > this.assessmentIdx
        ? this.assessments[this.assessmentIdx]
        : null;
    },
    filteredAssessments() {
      let assessments = this.assessments.filter(anAssessment => {
        return (
          !anAssessment.answers ||
          (Array.isArray(anAssessment.answers) &&
            anAssessment.answers.length == 0)
        );
      });
      return assessments;
    },
    assessmentsCount() {
      return this.assessments && Array.isArray(this.assessments)
        ? this.assessments.length
        : 0;
    },
    newAssessmentsCount() {
      return this.assessmentsUnanswered &&
        Array.isArray(this.assessmentsUnanswered)
        ? this.assessmentsUnanswered.length
        : 0;
    },
    subjective() {
      return this.output && this.output["assessmentsubjective"]
        ? this.output["assessmentsubjective"]
        : "N/A";
    },
    objective() {
      return this.output && this.output["assessmentobjective"]
        ? this.output["assessmentobjective"]
        : "N/A";
    },
    canGenerate() {
      return this.newAssessmentsCount == 0;
    },
    canSaveAssessment() {
      return this.savedCPAssessmentInfo != this.unSavedCPAssessmentInfo;
    },
    savedCPAssessmentInfo() {
      return this.carePlan && this.carePlan.plan.assessments
        ? this.getAssessmentInfo(this.carePlan.plan.assessments)
        : null;
    },
    unSavedCPAssessmentInfo() {
      return this.assessments ? this.getAssessmentInfo(this.assessments) : null;
    }
  },
  methods: {
    handleQuestionAnswerInput(id, object) {
      debugger;
      if (this.assessments && Array.isArray(this.assessments)) {
        let theAssessments = this.assessments.filter(anAssessment => {
          return anAssessment.id == id;
        });
        if (
          theAssessments &&
          Array.isArray(theAssessments) &&
          theAssessments.length == 1
        ) {
          let createdBy = this.profileBy();
          object._created_at = new Date();
          object._created_by = createdBy;

          if (
            theAssessments[0] &&
            theAssessments[0].answers &&
            Array.isArray(theAssessments[0].answers)
          ) {
            theAssessments[0].answers.push(object);
            theAssessments[0]._updated_at = new Date();
            theAssessments[0]._updated_by = createdBy;
          }
        }
      }
      if (this.newAssessmentsCount == 0) {
        this.handleUpdateAssessment();
      }
    },
    handleGeneratePlan() {
      this.$emit("generate-plan");
    },
    handleUpdateAssessment() {
      let createdBy = this.profileBy();
      this.$store
        .dispatch("provider/updateCarePlanAssessments", {
          path: this.pathRootDoc,
          plan: this.carePlan,
          version: 1,
          assessments: this.assessments,
          updatedBy: createdBy
        })
        .then(() => {
          this.$store.dispatch("user/showNotification", {
            title: "Assessments Saved",
            description: "Your assessments have been saved ",
            variant: "info"
          });
        })
        .catch(err => {});
    },
    processDoc() {
      if (this.doc) {
        this.assessments.forEach(anAssessment => {
          anAssessment.input = this.doc[anAssessment.key]
            ? this.doc[anAssessment.key]
            : null;
        });
      }
    },
    profileBy() {
      return {
        uid: this.profile && this.profile.userId ? this.profile.userId : null,
        name: this.profile
          ? `${this.profile.firstname} ${this.profile.lastname}`
          : null,
        imgURL: this.profile ? this.profile.imgURL : null
      };
    },
    getAssessmentInfo(assessments) {
      let assessmentInfo = "";
      if (assessments && Array.isArray(assessments)) {
        assessments.forEach(anAssessment => {
          //@TODOSort the Answers from earliest to
          if (
            anAssessment.question &&
            anAssessment.answers &&
            Array.isArray(anAssessment.answers) &&
            anAssessment.answers[0] &&
            anAssessment.answers[0].text
          ) {
            assessmentInfo += `\n\nQuestion: ${anAssessment.question} \n`;
            assessmentInfo += `Answer: ${anAssessment.answers[0].text}`;
          }
        });
      }
      return assessmentInfo;
    },
    handleToggleClick() {
      this.isViewableForCPS = !this.isViewableForCPS;
    },
    handleAssessmentPageTo(assessmentIdx) {
      this.assessmentIdx = assessmentIdx;
    }
  },
  watch: {
    doc(newValue, oldValue) {
      if (newValue) {
        this.processDoc();
      }
    },
    filteredAssessments(newValue, oldValue) {
      if (newValue) {
        this.$forceUpdate();
      }
    }
  },
  data() {
    return {
      assessmentIdx: 0,
      isViewableForCPS: false,
      heartbeatName:
        this.heartbeat && this.heartbeat.firstname
          ? this.heartbeat.firstname
          : "None",
      famName:
        this.profile && this.profile.firstname
          ? this.profile.firstname
          : "None",
      famRelation:
        this.profile && this.profile.relation ? this.profile.relation : "None",
      info:
        this.section && this.section.info && Array.isArray(this.section.info)
          ? this.section.info
          : [this.section.info],
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 200,
        height: 200,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.container .vue-grid-item.vue-grid-placeholder {
  background: #c0c081;
}
</style>
